import { useUsersLookup } from '@/components/access/users/hooks';
import { getInitials } from '@/shared/lib/names';
import type { User } from '@/shared/types/user';
import { Avatar } from '@heroui/react';

export function UserItem({
  item,
  className,
  email = true,
  size = 'sm',
  fontSize = 'sm',
  fontWeight = 'normal',
  hashColor = true,
}: {
  item: User;
  className?: string;
  email?: boolean;
  size?: 'sm' | 'xs';
  fontSize?: 'sm' | 'md' | 'lg';
  fontWeight?: 'normal' | 'medium' | 'bold';
  hashColor?: boolean;
}) {
  const nameClasses =
    { sm: 'text-small', md: 'text-medium', lg: 'text-large' }[fontSize] +
    ' ' +
    { normal: 'font-normal', medium: 'font-medium', bold: 'font-bold' }[
      fontWeight
    ];
  const style = hashColor
    ? { backgroundColor: stringToHSL(item.data.displayName), color: 'white' }
    : {};

  return (
    <div className={`flex items-center gap-2 ${className || ''}`}>
      <Avatar
        alt={item.data.displayName}
        name={getInitials(item.data.displayName)}
        className={`flex-shrink-0 ${size === 'xs' ? 'h-6 w-6 text-xs' : ''}`}
        // color='primary'
        style={style}
        size={size === 'xs' ? undefined : size}
      />
      <div className='flex flex-col'>
        <span className={nameClasses}>{item.data.displayName}</span>
        {email && (
          <span className='text-tiny text-default-500'>{item.data.email}</span>
        )}
      </div>
    </div>
  );
}

function stringToHSL(str: string, saturation = 50, lightness = 50) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash % 360);

  return `hsl(${hue},${saturation}%,${lightness}%)`;
}

export function UserSet({
  ids,
  render = 'item',
}: {
  ids: string[];
  render?: 'text' | 'item';
}) {
  const lookup = useUsersLookup();
  const users = ids
    .map((id) => {
      const user = lookup[id] || undefined;

      return user;
    })
    .filter((user) => Boolean(user));
  if (render === 'text') {
    const text = users.map((user) => user.data.displayName).join(', ');

    return <div>{text}</div>;
  }

  return (
    <div className='flex flex-wrap gap-1'>
      {users.map((user) => (
        <UserItem
          key={user.id}
          item={user}
          email={false}
          size='xs'
          className='rounded-full bg-default-100 p-1 pr-3'
        />
      ))}
    </div>
  );
}
